import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function listClients() {
  const { data } = await axios.get(`${API}/clients`);
  return data.clients;
}

export async function createClient(payload) {
  const { data } = await axios.post(`${API}/clients`, payload);
  return data;
}

export async function getClient(id) {
  const { data } = await axios.get(`${API}/clients/${id}`);
  return data;
}

export async function deleteClient(id) {
  const { data } = await axios.delete(`${API}/clients/${id}`);
  return data;
}

export async function saveClientState(id, progress, stats) {
  const { data } = await axios.put(`${API}/clients/${id}/state`, { progress, stats });
  return data;
}

export async function getClientAssessment(id) {
  const { data } = await axios.get(`${API}/clients/${id}/assessment`);
  return data;
}

export async function setClientLevel(id, knowledge_level) {
  const { data } = await axios.put(`${API}/clients/${id}/level`, { knowledge_level });
  return data;
}

export async function regenerateAssessment(id) {
  const { data } = await axios.post(`${API}/clients/${id}/regenerate-assessment`);
  return data;
}

// public practice (no auth)
export async function getPractice(token) {
  const { data } = await axios.get(`${API}/practice/${token}`);
  return data;
}

export async function practiceQuiz(token, topic, difficulty) {
  const { data } = await axios.post(`${API}/practice/${token}/quiz`, { topic, difficulty });
  return data;
}

// public assessment (no auth) - use a bare axios to avoid the bearer interceptor side effects
export async function getAssessment(token) {
  const { data } = await axios.get(`${API}/assessment/${token}`);
  return data;
}

export async function submitAssessment(token, answers) {
  const { data } = await axios.post(`${API}/assessment/${token}/submit`, { answers });
  return data;
}
